import React from "react";
import "normalize.css";
import "./Constants.css"

import Home from "./components/Home/Home";
import News from "./components/News/News";
import Contact from "./components/Contact/Contact";
import PrivacyPolicy from "./components/Legal/Privacy-Policy/Privacy-Policy";
import CookiePolicy from "./components/Legal/Cookie-Policy/Cookie-Policy";

// About Section
import Mission from "./components/About/Mission/Mission";
import OurTeam from "./components/About/Our-Team/Our-Team";
import OurImpact from "./components/About/OurImpact/OurImpact";
import Partnerships from "./components/About/Partnerships/Partnerships";

// Main Sections
import Training from "./components/Training/Training";
import TrainingPage from "./components/Training/TrainingPage";
import CoursePage from "./components/Training/CoursePage";
import PersonalTraining from "./components/Training/PersonalTraining/PersonalTraining";
import BusinessTraining from "./components/Training/BusinessTraining/BusinessTraining";
import EmploymentSupport from "./components/EmploymentSupport/EmploymentSupport";
import EmploymentSupportPage from "./components/EmploymentSupport/EmploymentSupportPage";
import CommunityProjects from "./components/CommunityProjects/CommunityProjects";
import CommunityProjectPage from "./components/CommunityProjects/CommunityProjectPage";
import NCILYouthCodingCamp from "./components/CommunityProjects/NCILYouthCodingCamp/NCILYouthCodingCamp";
import AdvocacyServices from "./components/CommunityProjects/AdvocacyServices/AdvocacyServices";
import Women4Women from "./components/CommunityProjects/Women4Women/Women4Women";
import CommunityOutreach from "./components/CommunityProjects/CommunityOutreach/CommunityOutreach";

// Get Involved
import GetInvolvedPage from "./components/GetInvolved/GetInvolvedPage";
import PartnerWithUs from "./components/GetInvolved/PartnerWithUs/PartnerWithUs";
import Volunteer from "./components/GetInvolved/Volunteer/Volunteer";

import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";



function App() {
  return (
    <main>
      <ScrollToTop />
      <Routes>
        {/* Main Pages */}
        <Route exact path="/" element={<Home />} />
        <Route path="news" element={<News />} />
        <Route path="contact" element={<Contact />} />
        
        {/* About Section */}
        <Route path="about/mission-values" element={<Mission />} />
        <Route path="about/leadership-team" element={<OurTeam />} />
        <Route path="about/our-impact" element={<OurImpact />} />
        <Route path="about/partnerships" element={<Partnerships />} />
        <Route path="mission" element={<Mission />} /> {/* Legacy redirect */}
        <Route path="our-team" element={<OurTeam />} /> {/* Legacy redirect */}

        {/* Training Section */}
        <Route path="training" element={<Training />} />
        <Route path="training/personal" element={<PersonalTraining />} />
        <Route path="training/business" element={<BusinessTraining />} />
        <Route path="training/personal/:categoryId/:programmeId" element={<CoursePage />} />
        <Route path="training/business/:packageId" element={<CoursePage />} />
        <Route path="training/personal/:categoryId" element={<TrainingPage />} />

        {/* Employment Support Section */}
        <Route path="employment-support" element={<EmploymentSupport />} />
        <Route path="employment-support/:id" element={<EmploymentSupportPage />} />

        {/* Community Projects Section */}
        <Route path="community-projects" element={<CommunityProjects />} />
        <Route path="community-projects/advocacy-services" element={<AdvocacyServices />} />
        <Route path="community-projects/ncil-youth-coding-camp" element={<NCILYouthCodingCamp />} />
        <Route path="community-projects/women-4-women" element={<Women4Women />} />
        <Route path="community-projects/community-outreach" element={<CommunityOutreach />} />
        <Route path="community-projects/:id" element={<CommunityProjectPage />} />

        {/* Get Involved Section */}
        <Route path="get-involved/volunteer" element={<Volunteer />} />
        <Route path="get-involved/partner" element={<PartnerWithUs />} />
        <Route path="get-involved/:id" element={<GetInvolvedPage />} />

        {/* Legal Pages */}
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </main>
  );
}

export default App;
